import {
    keyMirror
} from '../../helpers';

export default keyMirror({
    iRedeemConfirmationEndActionUnauthParamsDto: null,
    iCompletePhoneVerificationActionUnauthParamsDto: null
});